import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle` 
.ancharTag {
	width: 228px;
	height: 40px;
	border-radius: 4px;
	margin: auto;
	font: normal normal normal 16px/12px Roboto;
	opacity: 1;
	border: 2px solid transparent;
	display: flex;
	align-items: center;
	position: relative;
	text-decoration: none;
    padding-left:16px;
    padding-right:16px;
    margin-bottom:6px;
    gap:8px;
	}
    .ancharTag:focus-visible {
    border: 2px solid #002855 !important;
    outline: none;
}
    .selected {
		background-color: #007dba;
		border: 2px #007dba !important;
        color: #ffffff;
	}
        .ancharTag.selected span, .ancharTag.selected:hover span {
    color: #fff;
}

.main-menu:hover{
background-color: #007dba;
		border: 2px #007dba !important;
        color: #ffffff;
}
 
.ancharTag.main-menu:hover span, .ancharTag.main-menu:hover svg{
color:#fff;
}

.ancharTag.selected svg {
    color: #fff;
    width: 18px;
    height: 18px;
}
    .selected:hover{
    border: 2px #002855 !important;
    opacity: 1;
    background-color: #002855 !important;
    }
   
    .sub-menu-selected {
    margin-bottom: 6px !important;
    background-color: #CFDBE5 !important;
    }

    .sub-menu:hover {
    background-color: #cfdbe5 !important;
    }

    .sub-menu-selected:hover {
    background-color: #565a5c !important;
    }

     .ancharTag.selected.sub-menu-selected:hover span {
    color: #fff !important;
}

.ancharTag.selected.sub-menu-selected:hover svg {
    color: #fff !important;
}
    .miniSideBar {
	width: 42px;
	height: 40px;
    margin:0px;
	padding-left:12px;
    padding-right:16px;
    margin-bottom:6px;
    margin-top:2px !important;
    margin-left:2px !important;
	}
     .subMenuMiniSideBar {
	width: 42px;
	height: 40px;
    margin:0px;
	padding-left:0px;
    padding-right:0px;
    margin-bottom:6px;
    margin-top:2px !important;
    margin-left:2px !important;
    display:flex;
    justify-content:center;
    align-items:center;
	}
    .buttonFocus:focus-visible{
    border: 2px solid #002855 !important;
    }
`;

export default GlobalStyle;
